import { createActions, createAction } from 'redux-actions';

export const moduleName = 'subscriptions';

export const SUBSCRIPTION_SELECT = `${moduleName}/SUBSCRIPTION_SELECT`;
export const SUBSCRIPTION_PICK = `${moduleName}/SUBSCRIPTION_PICK`;
export const SUBSCRIPTION_CONFIRM = `${moduleName}/SUBSCRIPTION_CONFIRM`;
export const SUBSCRIPTION_CONFIRM_SUCCEEDED = `${moduleName}/SUBSCRIPTION_CONFIRM_SUCCEEDED`;
export const SUBSCRIPTION_CONFIRM_FAILED = `${moduleName}/SUBSCRIPTION_CONFIRM_FAILED`;
export const SUBSCRIPTION_UPGRADE_RESET = `${moduleName}/SUBSCRIPTION_UPGRADE_RESET`;
export const SUBSCRIPTION_RENEW_RESET = `${moduleName}/SUBSCRIPTION_RENEW_RESET`;
export const SUBSCRIPTION_RENEW_REQUESTED = `${moduleName}/SUBSCRIPTION_RENEW_REQUESTED`;
export const SUBSCRIPTION_RENEW_SUCCEEDED = `${moduleName}/SUBSCRIPTION_RENEW_SUCCEEDED`;
export const SUBSCRIPTION_RENEW_FAILED = `${moduleName}/SUBSCRIPTION_RENEW_FAILED`;
export const SUBSCRIPTION_UPGRADE_REQUESTED = `${moduleName}/SUBSCRIPTION_UPGRADE_REQUESTED`;
export const SUBSCRIPTION_UPGRADE_SUCCEEDED = `${moduleName}/SUBSCRIPTION_UPGRADE_SUCCEEDED`;
export const SUBSCRIPTION_UPGRADE_FAILED = `${moduleName}/SUBSCRIPTION_UPGRADE_FAILED`;

export const {
  subscriptions: {
    subscriptionSelect,
    subscriptionPick,
    subscriptionConfirm,
    subscriptionConfirmFailed,
    subscriptionRenewRequested,
    subscriptionRenewSucceeded,
    subscriptionRenewFailed,
    subscriptionUpgradeRequested,
    subscriptionUpgradeSucceeded,
    subscriptionUpgradeFailed,
  },
} = createActions({
  [SUBSCRIPTION_SELECT]: [
    payload => payload,
    () => ({ selfClosing: false }),
  ],
  [SUBSCRIPTION_PICK]: payload => payload,
  [SUBSCRIPTION_CONFIRM]: payload => payload,
  [SUBSCRIPTION_CONFIRM_FAILED]: payload => payload,
  [SUBSCRIPTION_UPGRADE_REQUESTED]: payload => payload,
  [SUBSCRIPTION_UPGRADE_SUCCEEDED]: payload => payload,
  [SUBSCRIPTION_UPGRADE_FAILED]: payload => payload,
  [SUBSCRIPTION_RENEW_REQUESTED]: payload => payload,
  [SUBSCRIPTION_RENEW_SUCCEEDED]: payload => payload,
  [SUBSCRIPTION_RENEW_FAILED]: payload => payload,
});

export const subscriptionConfirmSucceeded = createAction(SUBSCRIPTION_CONFIRM_SUCCEEDED);
export const subscriptionUpgradeReset = createAction(SUBSCRIPTION_UPGRADE_RESET);
export const subscriptionRenewReset = createAction(SUBSCRIPTION_RENEW_RESET);

